import { getField, updateField } from 'vuex-map-fields'
import getBusinessEntityFiltersModel from './models/businessEntityFilters'

const businessEntityFilters = {
  namespaced: true,
  state: {
    ...getBusinessEntityFiltersModel()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      state.id = null
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default businessEntityFilters
